import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Shop from "./Pages/Shop";
import Cart from "./Pages/Cart";
import Examelist from "./Components/ExameList/ExameList.jsx";
import Product from "./Pages/Product";
import Footer from "./Components/Footer/Footer";
import TodosMedicos from "./Components/TodosMedicos/TodosMedicos";
import Sobre from "./Components/About/About";
import Importancia from "./Components/ImportanceOfHealth/ImportanceOfHealth";
import ResultadosExames from "./Pages/ResultadosExames";
import { useEffect } from "react";
import clinicaConfig from "./clinicaConfig.js";
import logoclinic from "./Components/Assets/logocurta.png";


function App() {
  useEffect(() => {
    document.title = clinicaConfig.nomeClinica;

    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = logoclinic;
    }
  }, []);

  return (
    <div className="app-container">
      <Router>
        <Navbar />
        <div className="router-content">
          <Routes>
            <Route path="/" element={<Shop gender="all" />} />
            <Route path="/Lista-de-exames" element={<Examelist />} />
            <Route path="/Lista-de-exames/:productId" element={<Product />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/todos-medicos" element={<TodosMedicos />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/importancia-da-saude" element={<Importancia />} />
            <Route path="/resultados-exames" element={<ResultadosExames />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
